import { style } from 'constant/constants';
import { Grid, InputLabel, MenuItem, Select } from '@mui/material/index';
import PropTypes from 'prop-types';

const dropdownOptions = [
  { name: 'Raw Steel' },
  { name: 'Zinc Plated Steel' },
  { name: 'Powder Coated Steel' },
  { name: 'Copper' }
];

const SortDropdownFence = ({ setSortByMaterial, sortByMaterial }) => {
  const handleChange = (event) => {
    setSortByMaterial(event.target.value);
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        width: 400,
        height: 30,
        backgroundColor: '',
        justifyContent: 'flex-end',
        marginRight: 1
      }}
      display="flex">
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          mr: 1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green">
        Filter Selection
      </InputLabel>
      <Select
        value={sortByMaterial}
        size="small"
        sx={{ width: 210, fontFamily: style.fontFamily, mt: -0.4, mb: 0, height: 30 }}
        name="Material"
        onChange={handleChange}>
        {dropdownOptions?.length > 0 &&
          dropdownOptions.map((material) => (
            <MenuItem
              value={material.name}
              key={material.name}
              sx={{ fontFamily: style.fontFamily }}>
              {material.name}
            </MenuItem>
          ))}
      </Select>
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          ml: 1,
          mr: -1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green">
        {/* to sort by price (in ascending order) */}
      </InputLabel>
    </Grid>
  );
};

export default SortDropdownFence;

SortDropdownFence.propTypes = {
  setSortByMaterial: PropTypes.func,
  sortByMaterial: PropTypes.string
};
